export default "__VITE_PUBLIC_ASSET__6bd198ee__"